import React, { useContext } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { Button, Card, Tooltip, message } from 'antd';
import { TrophyOutlined, GlobalOutlined, DeleteOutlined } from '@ant-design/icons';
import { Scrollbars } from 'react-custom-scrollbars';
import { removeParticipantFromGroup } from 'api/teams';
import { EventContext } from 'modules/dashboard/pagesv2/event';
import Avatar from 'antd/lib/avatar/avatar';
import AvatarStatus from 'componentsv2/AvatarStatus/AvatarStatus';

const InnerCardList = React.memo(function InnerCardList(props) {
  const { eventId } = useContext(EventContext);

  const deleteParticipant = async (eventId, groupId, clubId) => {
    message.loading('Removiendo equipo', 1);
    try {
      await removeParticipantFromGroup(eventId, groupId, clubId);
      props.reloadGroups();
      message.success('!Club removido con éxito!');
    } catch (error) {
      message.error('!Ha ocurrido un error!');
    }
  };

  if (!Array.isArray(props.contents))
    return (
      <div className="d-flex justify-content-center align-items-center">
        No hay datos de posiciones.
      </div>
    );

  if (props.contents.length === 0)
    return (
      <div className="d-flex justify-content-center align-items-center">
        Arrastra desde la lista derecha los equipos que serán parte de este grupo.
      </div>
    );

  if (props?.contents[0]?.points || props?.contents[0]?.points === 0) {
    return props.contents?.map((item, index) => (
      <Draggable key={item.club.id} draggableId={String(item.club.id)} index={index}>
        {(dragProvided, dragSnapshot) => (
          <div
            className="mb-3"
            key={item.club.id}
            ref={dragProvided.innerRef}
            {...dragProvided.draggableProps}
            {...dragProvided.dragHandleProps}
          >
            <Card hoverable className="board-card" cover={null}>
              <h4 className="mb-2">{item.club.name}</h4>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <TrophyOutlined style={{ color: 'gold' }} />
                  <span className="ml-1 mr-1 font-weight-semibold">{`Rank: ${index + 1}`}</span>
                  <GlobalOutlined style={{ color: '#001529' }} className="ml-1" />
                  <span className="ml-1 font-weight-semibold">{`Points: ${item.points}`}</span>
                </div>
                <div className="d-flex">
                  <Avatar size="small" src={item?.club?.avatar_url} />
                </div>
              </div>
            </Card>
          </div>
        )}
      </Draggable>
    ));
  }

  if (props?.contents[0]?.hasOwnProperty('current')) {
    return props.contents?.map((item, index) => (
      <Draggable key={item.club.id} draggableId={String(item.club.id)} index={index}>
        {(dragProvided, dragSnapshot) => (
          <div
            className="mb-3"
            key={item.club.id}
            ref={dragProvided.innerRef}
            {...dragProvided.draggableProps}
            {...dragProvided.dragHandleProps}
          >
            <Card hoverable className="board-card" cover={null}>
              <div className="d-flex justify-content-between align-items-center">
                <AvatarStatus src={item?.club?.avatar_url} name={item?.club?.name} />
              </div>
            </Card>
          </div>
        )}
      </Draggable>
    ));
  }

  return props.contents?.map((item, index) => {
    return (
      <div className="mb-3" key={item.id}>
        <Card className="board-card" cover={null}>
          <div className="d-flex justify-content-between align-items-center">
            <AvatarStatus src={item?.club?.avatar_url} name={item?.club?.name} />
            {!props.roundsGenerated && (
              <Tooltip title="Eliminar club">
                <Button
                  onClick={() => deleteParticipant(eventId, props.listId, item?.club?.id)}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                />
              </Tooltip>
            )}
          </div>
        </Card>
      </div>
    );
  });
});

function InnerList(props) {
  const { contents, dropProvided, listId, roundsGenerated, reloadGroups } = props;
  return (
    <div className="board-dropzone" ref={dropProvided.innerRef}>
      <InnerCardList
        roundsGenerated={roundsGenerated}
        contents={contents}
        listId={listId}
        reloadGroups={reloadGroups}
      />
      {dropProvided.placeholder}
    </div>
  );
}

export default function GroupCard(props) {
  const {
    ignoreContainerClipping,
    internalScroll,
    scrollContainerStyle,
    isDropDisabled,
    isCombineEnabled,
    listId = 'LIST',
    listType,
    style,
    contents,
    useClone,
    roundsGenerated,
    reloadGroups,
  } = props;
  return (
    <>
      <Droppable
        droppableId={listId}
        type={listType}
        ignoreContainerClipping={ignoreContainerClipping}
        isDropDisabled={isDropDisabled}
        isCombineEnabled={isCombineEnabled}
        renderClone={useClone}
      >
        {(dropProvided, dropSnapshot) => (
          <Scrollbars
            style={style}
            className="board-wrapper"
            autoHide
            {...dropProvided.droppableProps}
          >
            {internalScroll ? (
              <div className="board-scrollContainer" style={scrollContainerStyle}>
                <InnerList
                  contents={contents}
                  listId={listId}
                  dropProvided={dropProvided}
                  roundsGenerated={roundsGenerated}
                  reloadGroups={reloadGroups}
                />
              </div>
            ) : (
              <InnerList
                contents={contents}
                listId={listId}
                dropProvided={dropProvided}
                roundsGenerated={roundsGenerated}
                reloadGroups={reloadGroups}
              />
            )}
          </Scrollbars>
        )}
      </Droppable>
    </>
  );
}
